module.exports = __webpack_public_path__ + "3a1f986c48648af1967b32b562577148.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fortinet_2022_chart.png
// module id = 1680
// module chunks = 0